import { Settings } from './settings';
import { AutosCoordinates } from './autosCoordinates';
import { LoadingStatus } from 'shared/constants';
import { UserLocation } from 'entities/users';
import { GeoCoords } from 'common/utils/Map';

export const STATE = 'USER';

export type Card = {
  cardNumber: string;
  autoNumber: Nullable<string>;
};
export interface State {
  settings: Settings;
  autosCoordinates: AutosCoordinates;
  cards: {
    loadingStatus?: LoadingStatus;
    data?: Card[];
  };
  currentLocation: {
    loadingStatus?: LoadingStatus;
    data?: UserLocation[];
  };
  historyUserLocation: {
    loadingStatus?: LoadingStatus;
    data?: UserLocation[];
  };
  geoPosition: {
    geoCords?: GeoCoords | null;
    loadingStatus?: LoadingStatus;
  };
}
